import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { FTSE4GoodPageContent } from "./FTSE4GoodPageContent";
import { FTSE4GoodPageHeading } from "./FTSE4GoodPageHeading";
export const FTSE4Good = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Content",
      key: "ftse4goodMainContent",
      children: <FTSE4GoodPageContent/>
    },
    {
      label: "Page Heading",
      key: "ftse4GoodPageHeading",
      children: <FTSE4GoodPageHeading/>
    }, 
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
